import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from '@/icons';
import './help-tour.css';

interface ShowAroundButtonProps {
  onClick: () => void;
}

const ShowAroundButton: React.FC<ShowAroundButtonProps> = ({ onClick }) => {
  const { t } = useTranslation('help');

  return (
    <button type="button" className="show-around" onClick={onClick} title={t('showAround.title')}>
      <Sparkles width={13} height={13} />
      {t('showAround.label')}
    </button>
  );
};

export default ShowAroundButton;
